"use client";
import { EXCLUDEDROUTES } from "@/app/consts/common";
import { publicEnvConfig } from "@/app/utils/config/config";
import Hotjar from "@hotjar/browser";
import { usePathname } from "@/i18n/navigation";
import { useEffect } from "react";

const UseHotjar = () => {
  const siteId = parseInt(publicEnvConfig.hotjarSiteId);
  const hotjarVersion = parseInt(publicEnvConfig.hotjarVersion);
  const pathname = usePathname();

  useEffect(() => {
    if (!EXCLUDEDROUTES.includes(pathname)) {
      Hotjar.init(siteId, hotjarVersion);
    }

    const handleRouteChange = (event: PopStateEvent) => {
      const newUrl = (event.currentTarget as Window).location.pathname;
      if (!EXCLUDEDROUTES.includes(newUrl)) {
        Hotjar.init(siteId, hotjarVersion);
      }
    };

    window.addEventListener("popstate", handleRouteChange);

    return () => {
      window.removeEventListener("popstate", handleRouteChange);
    };
  }, [siteId, hotjarVersion, pathname]);

  return null;
};

export default UseHotjar;
